import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Linkedin, Instagram, Github, Mail, MapPin, Phone, ArrowRight } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const solutions = [{
    title: "AI-Generated Custom Images",
    href: "/SolutionsPage"
  }, {
    title: "AI-Produced Marketing Videos",
    href: "/SolutionsPage"
  }, {
    title: "Educational Tutorials",
    href: "/SolutionsPage"
  }, {
    title: "E-learning Modules",
    href: "/SolutionsPage"
  }, {
    title: "Branding Guides",
    href: "/SolutionsPage"
  }, {
    title: "Professional Presentations",
    href: "/SolutionsPage"
  }];
  const companyLinks = [{
    title: "About Us",
    href: "/HomePage"
  }, {
    title: "Our Impact",
    href: "/ImpactPage"
  }, {
    title: "Careers",
    href: "/ContactPage"
  }, {
    title: "News & Media",
    href: "/HomePage"
  }, {
    title: "Contact",
    href: "/ContactPage"
  }];

  // const socialLinks = [
  //   { icon: Twitter, href: "#", label: "Twitter" },
  //   { icon: Facebook, href: "#", label: "Facebook" },
  //   { icon: Instagram, href: "#", label: "Instagram" },
  // ];

  return <section id="footer" className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-900 via-primary to-blue-900 shadow-[0_0_15px_rgba(59,130,246,0.5)]" />

      <div className="container mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {}
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              {}
              <img src="https://just-shepherd.10web.cloud/wp-content/uploads/2026/02/medienschmiede_ai_logo_white_transparent_tight-scaled.png" alt="AIMediaForge Logo" className="h-7 w-auto object-contain" />
            </div>

            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              medienschmiede.ai nutzt künstliche Intelligenz, um hochwertige visuelle und didaktische
              Inhalte zu produzieren. Wir befähigen Dein Unternehmen, Zielgruppen mit schnellen,
              skalierbaren und kosten-günstigen Lösungen wirkungsvoll zu erreichen.
            </p>

            {/*
             <div className="pt-2">
              <h4 className="text-sm font-semibold tracking-wider uppercase text-primary mb-4">Folge uns</h4>
              <div className="flex gap-3">
                {socialLinks.map((social, i) => (
                  <Link
                    key={i}
                    to={social.href}
                    className="group relative flex items-center justify-center w-10 h-10 rounded-full bg-background border border-slate-700 hover:border-primary transition-all duration-300 hover:shadow-[0_0_10px_rgba(59,130,246,0.3)]"
                    aria-label={social.label}
                    data-index={i}
                  >
                    <social.icon className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors" />
                  </Link>
                ))}
              </div>
             </div>
             */}
          </div>

          {}
          

          {}
          

          {}
          <div>
            <h3 className="text-lg font-bold mb-6 text-foreground tracking-tight">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground group">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5 group-hover:text-blue-400 transition-colors" />
                <span className="group-hover:text-foreground transition-colors">
                  Halle (Westf.) &amp; Mannheim
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground group">
                <Phone className="w-5 h-5 text-primary shrink-0 group-hover:text-blue-400 transition-colors" />
                <span className="group-hover:text-foreground transition-colors">
                  +49 (0)174 9549784
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground group">
                <Mail className="w-5 h-5 text-primary shrink-0 group-hover:text-blue-400 transition-colors" />
                <span className="group-hover:text-foreground transition-colors">
                  kontakt@medienschmiede.ai
                </span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-border/30 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© {currentYear} medienschmiede.ai. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/ImpressumPage" className="hover:text-primary transition-colors">
              Impressum
            </Link>
            <Link to="/DataProtectionPage" className="hover:text-primary transition-colors">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </section>;
}